<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('PlatformSettings.name')">
                    <el-input
                      size="mini"
                      v-model="formInline.zhName"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <!-- <el-button
                  type="text"
                  @click="editUser"
                  :disabled="this.selected.length != 1"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  type="text"
                  @click="deleteUser"
                  :disabled="this.selected.length != 1"
                  >{{ $t("common.btn.delete") }}</el-button
                > -->
                <el-button type="text" @click="addMoudle">{{
                  $t("common.btn.add")
                }}</el-button>
              </div>
              <div class="rightAll-table">
                <el-table
                  height="700"
                  :data="tableData"
                  row-key="id"
                  border
                  stripe
                  
                  :tree-props="{
                    children: 'children',
                  }"
                >
                  <el-table-column
                    align="center"
                    label="序号"
                    type="index"
                    width="50"
                  >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="zhName"
                    label="名称"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="menuTypeName"
                    label="系统"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="nodeTypeName"
                    label="类型"
                  >
                  </el-table-column>
                  <el-table-column align="center" prop="menuIcon" label="图标">
                  </el-table-column>
                  <el-table-column align="center" prop="orderSort" label="排序">
                  </el-table-column>
                  <el-table-column align="center" prop="path" label="页面路由">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    fixed="right"
                    label="操作"
                    width="160"
                  >
                    <template slot-scope="scope">
                      <el-button
                        @click="handleAdd(scope.row)"
                        type="text"
                        size="small"
                        >新增</el-button
                      >
                      <el-button @click="handleEdit(scope.row)" type="text" size="small">修改</el-button>
                      <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table> -->
              <!-- <IPagination ref="page" @PageFun="changeSize"></IPagination> -->
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="menuType"
            :label="$t('PlatformSettings.system') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              size="small"
              v-model="form.menuType"
              :placeholder="$t('common.choseTip')"
            >
              <el-option
                v-for="item in menuTypeList"
                :key="item.menuType"
                :label="item.menuTypeName"
                :value="item.menuType"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="name"
            :label="$t('PlatformSettings.englishName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="zhName"
            :label="$t('PlatformSettings.chineseName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.zhName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="nodeType"
            :label="$t('PlatformSettings.typesOf') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              size="small"
              v-model="form.nodeType"
              :placeholder="$t('common.choseTip')"
            >
              <el-option
                v-for="item in nodeTypeList"
                :key="item.nodeType"
                :label="item.nodeTypeName"
                :value="item.nodeType"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="menuIcon"
            :label="$t('PlatformSettings.icon') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.menuIcon"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="orderSort"
            :label="$t('TerminalCommand.sort') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input-number
              v-model="form.orderSort"
              class="mx-4"
              :min="0"
              :max="100"
              controls-position="right"
            />
          </el-form-item>
          <el-form-item
            prop="path"
            :label="$t('PlatformSettings.routingAddress') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.path"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
              v-if="isShow"
              prop="roleData"
              :label="$t('PlatformSettings.roleData')+':'"
              :label-width="formLabelWidth"
            >
              <el-button @click="getPower">{{$t('common.btn.click')}}</el-button>
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <!-- <el-dialog
        v-if="diaHidden"
        class="treeDialong"
        :title="$t('PlatformSettings.roleData')"
        :visible.sync="dialogPowerVisible"
        width="520px"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <div>
          <div>
            <el-input
              size="small"
              :placeholder="$t('common.filterTip')"
              v-model="filterText"
            >
            </el-input>
            <div style="height: 380px">
              <el-scrollbar>
                <el-tree
                  :data="data"
                  show-checkbox
                  ref="tree"
                  node-key="label"
                  :check-on-click-node="false"
                  :default-expanded-keys="keyList"
                  :default-checked-keys="keyList"
                  :filter-node-method="filterNode"
                  :props="defaultProps"
                  :check-strictly="true"
                  @check="handCheck"
                  @check-change="checkChange"
                >
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="handleClose">{{
              $t("common.btn.cancel")
            }}</el-button>
            <el-button size="small" type="primary" @click="submit('form')">{{
              $t("common.btn.confirm")
            }}</el-button>
          </span>
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import MenuManagement from "./MenuManagement";
export default MenuManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
